import React from 'react';
import { IntlProvider } from 'react-intl';
import { RouterProvider } from 'react-router-dom';
import translation from '@/translation';
import Cookies from 'js-cookie';

import muiTheme from '@/initializers/src/theme';
import { ThemeProvider } from '@mui/material/styles';

import router from '@/initializers/src/router/router';

const locales = Cookies.get('locale') || '{}';

function parseLocales() {
  try {
    const { locale } = JSON.parse(locales);

    switch (locale) {
      case 'en':
      case 'uk':
        return 'en';
      default:
        return locale;
    }
  } catch (error) {
    console.error('error parsing locales', error);
    return 'en';
  }
}

const AppUninitializedEnv = () => {
  const locale = parseLocales();

  // v7_startTransition stays off for the reason given in @/pages/RootRoute.
  return (
    <IntlProvider locale={locale} messages={translation[locale]} defaultLocale="en">
      <ThemeProvider theme={muiTheme}>
        <RouterProvider router={router} future={{ v7_startTransition: false }} />
      </ThemeProvider>
    </IntlProvider>
  );
};

export default AppUninitializedEnv;
